import * as React from "react";
const OutlineInfoIcon = (props: any) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.0013 12.8337C8.61212 12.8337 10.0705 12.1807 11.1261 11.1251C12.1817 10.0695 12.8346 8.61114 12.8346 7.00033C12.8346 5.38951 12.1817 3.93118 11.1261 2.87553C10.0705 1.81991 8.61212 1.16699 7.0013 1.16699C5.39049 1.16699 3.93215 1.81991 2.87651 2.87553C1.82089 3.93118 1.16797 5.38951 1.16797 7.00033C1.16797 8.61114 1.82089 10.0695 2.87651 11.1251C3.93215 12.1807 5.39049 12.8337 7.0013 12.8337Z"
      stroke="#6D77A0"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.9987 4.72591C7.4014 4.72591 7.72786 4.39945 7.72786 3.99674C7.72786 3.59404 7.4014 3.26758 6.9987 3.26758C6.59599 3.26758 6.26953 3.59404 6.26953 3.99674C6.26953 4.39945 6.59599 4.72591 6.9987 4.72591Z"
      fill="#6D77A0"
    />
    <path
      d="M7 5.83301V10.4997"
      stroke="#6D77A0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default OutlineInfoIcon;
